module.exports = __webpack_public_path__ + "static/media/leader_1.349628ba.png";